import { api } from "@/lib/api";

const REGION_BY_LANG = {
  "en-ie": "ie",
  "en-gb": "uk",
  "en-us": "global",
  "en-au": "uk",
  "ga-ie": "ie",
  "de-de": "de",
  "de-at": "at",
  "de-ch": "ch",
  "fr-fr": "fr",
  "fr-be": "be",
  "fr-ch": "ch",
  "it-it": "it",
  "es-es": "es",
  "nl-nl": "nl",
  "nl-be": "be",
};

const REGION_LABELS = {
  ie: "Ireland",
  uk: "United Kingdom",
  de: "Germany",
  at: "Austria",
  ch: "Switzerland",
  fr: "France",
  be: "Belgium",
  it: "Italy",
  es: "Spain",
  nl: "Netherlands",
  global: "Other",
};

const STORAGE_KEY = "alternavit_region_v1";

export function detectRegion() {
  const stored = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
  if (stored) return stored;
  const langs = (typeof navigator !== "undefined" && navigator.languages) || [navigator?.language || "en-US"];
  for (const raw of langs) {
    const l = (raw || "").toLowerCase();
    if (REGION_BY_LANG[l]) return REGION_BY_LANG[l];
    const short = l.split("-")[0];
    const candidate = Object.entries(REGION_BY_LANG).find(([k]) => k.startsWith(short + "-"));
    if (candidate) return candidate[1];
  }
  return "global";
}

export function setRegion(region) {
  if (typeof window !== "undefined") localStorage.setItem(STORAGE_KEY, region);
}

export function regionLabel(region) {
  return REGION_LABELS[region] || "Other";
}

export const ALL_REGIONS = Object.keys(REGION_LABELS);

export async function trackAffiliateClick({ supplement_key, retailer, region, recommendation_id }) {
  try {
    await api.post("/affiliate/click", {
      supplement_key,
      retailer,
      region,
      recommendation_id: recommendation_id || null,
    });
  } catch {
    // best effort — never block the user's actual click-through
  }
}

export function openAffiliate({ supplement_key, retailer, region, recommendation_id, url }) {
  // fire-and-forget tracking, then open in new tab
  trackAffiliateClick({ supplement_key, retailer, region, recommendation_id });
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
